import React from "react";
import getOrderStatusDataForTrack, {
  allStatus
} from "../../../../../lib/getOrderStatusForTrack";

const AddressInformation = ({
  directions,
  handleClickDirections,
  restaurant,
  delivery,
  address,
  orderUid,
  restaurantDeliveryType,
  orderStatus
}) => {
  const getMapUrl = () => {
    const { lat, lon } = address ? address : null;
    return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lon}&style=feature:poi|visibility:off&zoom=18&size=700x150&key=AIzaSyDqIcW_O-zUO90BsNZQjed33BthNi19Egc`;
  };
  const url = getMapUrl();
  const canTrack = () => {
    const currentStatusId = getOrderStatusDataForTrack(orderStatus);
    const currentStatus = allStatus.find(
      status => status.id === currentStatusId
    );
    return (
      currentStatus &&
      orderStatus !== "ORDER_COMPLETED" &&
      restaurantDeliveryType === "THIRD_PARTY_DELIVERY"
    );
  };
  return (
    <div>
      {(canTrack() && (
        <a href={`/track-order/${orderUid}`}>
          <div className="delivery-track-link hide-xs">
            <div>
              {url && (
                <img
                  style={{ zIndex: -99, position: "relative", width: "100%" }}
                  src={url}
                />
              )}
            </div>
            <span style={{ position: "absolute", zIndex: 9999 }}>
              <img src="/svg/trakc-location.svg" />
              Track your order
            </span>
          </div>
        </a>
      )) || <noscript />}
      <div
        className={`delivery d-flex ${directions && "directions"}`}
        style={{ whiteSpace: "pre" }}
      >
        <icon className="icon icon-location-white" />
        {(directions && (
          <div
            onClick={() =>
              handleClickDirections(
                restaurant.address.lat,
                restaurant.address.lon
              )
            }
            className="cursor-pointer"
          >
            <h5>
              <span className="bold">Directions to {restaurant.name}</span>
            </h5>
            <p>
              {restaurant.address.addressLine1},{" "}
              {restaurant.address.addressLine2}, {restaurant.address.postalCode}
            </p>
          </div>
        )) || (
          <div>
            <h5 style={{ marginRight: "0px" }}>
              {(delivery && "Delivery To") || "Collection >"}{" "}
              <span className="bold">
                {(delivery && (address.title || address.addressLine1)) ||
                  `${restaurant.name}`}
                ,
              </span>
            </h5>
            <p>
              {(delivery &&
                ` ${address.postalCode}, ${address.addressLine2 ||
                  "London"}`) ||
                ` ${restaurant.address.addressLine1}, ${restaurant.address.postalCode}, ${restaurant.address.addressLine2}`}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddressInformation;
